import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import GLOBAL from 'jcolorglobal';
import TimeFormat from 'components/commons/TimeFormat';
import Dropdown from 'components/commons/Dropdown';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';

const MoreIcon = require('react-icons/lib/md/keyboard-control');

class AllowanceListItem extends PureComponent {

    static propTypes = {
        item: PropTypes.object.isRequired
    };

    constructor(props) {

        super(props);
        
        this.renderMenu = this.renderMenu.bind(this);
    }

    uploadToTurnkey(item) {

        // console.log(item);
        this.props.allowanceActions.uploadAllowanceToTurnkey({allowanceNumber: item.allowancenumber});
    }
    
    deleteAllowanceItem(item) {
        
        const allowanceNumber = item.allowancenumber;

        this.props.webActions.openConfirmDialog({
            title: '刪除折讓單？',
            description: '確定要刪除「' + allowanceNumber + '」該筆折讓單嗎？',
            isPromise: true,
            confirmPromise: () => {
                const promise = new Promise((resolve, reject) => {
                    this.props.allowanceActions.delAllowanceInvoice({
                        allowanceNumber: allowanceNumber,
                    }).then((result) => {
                        if (result) {
                            resolve(true);
                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    }, (error) => {
                        if (error && error.message) {
                            reject(error.message);
                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    });
                });
                return promise;
            },
        })
    }

    renderMenu(item) {

        return (
            <ul>
                <li>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.PRINT_ALLOWANCE}
                        params={{
                            allowancenumber: item.allowancenumber,
                        }}
                        target="_blank"
                    >
                        列印
                    </CupoySrefView>
                </li>
                {item.turnkeyupcasttime === -1 ?
                    <li onClick={(event) => this.uploadToTurnkey(item)}>
                        <a>買家接受折讓，上傳</a>
                    </li>
                    :
                    null
                }
                {item.turnkeyupcasttime <= -1 ?
                    <li onClick={(event) => this.deleteAllowanceItem(item)}>
                        <a>刪除</a>
                    </li>
                    :
                    null
                }
            </ul>
        )
    }
    render() {
        const {item} = this.props;

        const isTriCopy = item.buyercrn && item.buyercrn !== GLOBAL.DEFAULT_BUYERCRN;

        var status = '';

        if(item.turnkeyupcasttime === 0) {
            status = '上傳中';
        } else if(item.turnkeyupcasttime <= -1) {
            status = '等待買方接受';
        } else {
            status = '已上傳';
        }

        return (
            <tr className="table-list-row">
                <td className="table-list-col">
                    <CupoySrefView
                        statename={CupoyRouter.STATES.ALLOWANCE_INFO}
                        params={{
                            allowancenumber: item.allowancenumber,
                        }}
                    >
                        {item.allowancenumber}
                    </CupoySrefView>                
                    
                </td>
                <td className="table-list-col">
                    <TimeFormat format="simpleTime" time={item.detail.allowancedate}/>
                </td>
                <td className="table-list-col">
                    {item.detail.taxamount}
                </td>
                <td className="table-list-col">
                    <TimeFormat format="simpleTime" time={item.detail.invoicedate}/>
                </td>
                <td className="table-list-col">
                    {item.detail.invoicenumber}
                </td>
                <td className="table-list-col">
                    {isTriCopy
                        ? <span>三聯式</span>
                        : <span>二聯式</span>
}
                </td>
                <td className="table-list-col">
                    {item.buyername}
                </td>
                <td className="table-list-col">
                    {isTriCopy && item.buyercrn
                        ? item.buyercrn
                        : '-'}
                </td>
                <td className="table-list-col">
                    {status}
                </td>

                <Dropdown
                    defaultVisible={false}
                    overlay={this.renderMenu(item)}
                    trigger={['click']}
                    placement="bottomRight"
                    overlayClassName="dropdown popup open"
                    overlayStyle={{
                    position: 'absolute'
                }}
                    zIndex={2000}>
                    <td
                        className="table-list-col center action"
                        style={{
                        width: '40px'
                    }}>
                        <MoreIcon/>
                    </td>
                </Dropdown>
            </tr>
        );
    }
}


const mapStateToProps = function (state) {
    return {allowances: state.allowance.allowances};
};

const mapActionToProps = function (dispatch) {
    return {
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(AllowanceListItem);




// WEBPACK FOOTER //
// ./src/components/allowance/AllowanceListItem.jsx